export default "__VITE_ASSET__DJkGHMh0__"